import React from 'react';
import { Col } from 'reactstrap';
import { ContentItemFormSelect, ContentItemFormTitle } from '../../../styled';
import FormTooltip from 'components/Inputs/FormTooltip';
import { OptionalProtocolNumberPrefix } from '../../OptionalProtocolNumberPrefix';
import { ProtocolNumberConfig } from '../../ProtocolNumberConfig';

export function ProtocolNumberAndPrefixConfig({
  optionalProtocolNumberPrefix,
  setOptionalProtocolNumberPrefix,
  protocolNumberInfo,
  setProtocolNumber,
  recordTypeId
}) {
  const protocolNumberConfigSelectedValues = protocolNumberInfo?.find?.(
    (conf) => conf.record_type_id === recordTypeId
  )?.value;

  return (
    <>
      <Col md="3">
        <ContentItemFormTitle>
          <label>
            Prefixo do protocolo
            <FormTooltip text="Campo opcional para adicionar uma identificação extra no início do número de protocolo, antes dos campos tradicionais, conforme sua necessidade. Exemplo com campo fixo: G4F 2025 05 20 000001" />
          </label>
        </ContentItemFormTitle>
        <ContentItemFormSelect>
          <OptionalProtocolNumberPrefix
            onPrefixChange={setOptionalProtocolNumberPrefix}
            data={optionalProtocolNumberPrefix}
          />
        </ContentItemFormSelect>
      </Col>
      <Col md="6">
        <ContentItemFormTitle>
          <label>Configuração de número de protocolo</label>
        </ContentItemFormTitle>
        <ContentItemFormSelect>
          <ProtocolNumberConfig
            data={protocolNumberConfigSelectedValues}
            setProtocolNumber={setProtocolNumber}
          />
        </ContentItemFormSelect>
      </Col>
    </>
  );
}
